import * as z from "zod";

export const disconnectReturnsTiktokIntegration = {
  name: "disconnectReturnsTiktokIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
